import React, {useState} from "react";
import axios from "axios"
import { Link, Redirect } from "react-router-dom";

import Alert from "components/Alert/Alert.js";
import ModalBox from "components/Alert/Modal.js";

export default function Register() {

  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);  
  
  const [showAlert, setShowAlert] = useState(false); 
  const [enableSubmit, setEnableSubmit] = useState(false); 
   

  const [alertTitle, setAlertTitle] = useState("");  
  const [alertMSg, setAlertMSg] = useState("");  
  const [alertColor, setAlertColor] = useState("bg-green-500");  

  const [modalDetail, setModalDetail] = useState("");  
  const showModal = (title,desc) => {
    setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
        setModalDetail(<div></div>);
    }}/>);
  }

  const showInfo = () => {
    if (showAlert) {
      let response = <Alert title={alertTitle} message={alertMSg} color={alertColor} callback={()=>{
        setShowAlert(false);
      }}/>;
      return response;
    }
    return (<div></div>);
  }

  const registerUser = (e) => {
    e.preventDefault();
    setShowAlert(false);

    if (!enableSubmit) {
      setAlertTitle(<div></div>);
      setAlertMSg("Read and Accept Privacy Policy!");
      setAlertColor("bg-red-500");
      setShowAlert(true);
      return;
    }

    if (name.length<3 || lastname.length<3 || email.length<7 || password.length<7) {
      setAlertTitle(<div></div>);
      setAlertMSg("Check fields!");
      setAlertColor("bg-red-500");
      setShowAlert(true);
      return;
    }

    const data = {
      name: name,
      lastname: lastname,
      email: email,
      password: password
    }
    axios.post('register',data)
      .then(res=>{
        console.log(res);

        if (parseInt(res.data.code)===404) {          
          setAlertTitle(<div></div>);
          setAlertMSg("User is already exist!");
          setAlertColor("bg-red-500");
          setShowAlert(true);
          return;
        }

        if (parseInt(res.data.code)===200) {
          setAlertTitle(<div></div>);
          setAlertMSg("Registered..");
          setAlertColor("bg-green-500");
          setIsRegistered(true);
        }
      })
      .catch(err=>{
        console.log(err);
      })    
  }

  if (isRegistered) {
    return <Redirect to={'/admin'}/>;
  }

  return (
    <>
      {modalDetail}
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h6 className="text-gray-600 text-sm font-bold">
                    Sign up with
                  </h6>
                </div>
                <div className="btn-wrapper text-center">
                  <button
                    className="bg-white active:bg-gray-100 text-gray-800 font-normal px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 uppercase shadow hover:shadow-md inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
                    type="button"
                  >
                        <img
                          alt="MBlink"
                          className="mr-1"
                          src={require("assets/img/logo.png")}
                        />
                  </button>
                </div>
                <hr className="mt-6 border-b-1 border-gray-400" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                  <div className="flex flex-wrap">
                    <div className="w-full lg:w-6/12 pr-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                          placeholder="Name"
                          onChange={e=>setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="w-full lg:w-6/12">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Lastname
                        </label>
                        <input
                          type="text"
                          className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                          placeholder="Lastname"
                          onChange={e=>setLastname(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      onChange={e=>setEmail(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      onChange={e=>setPassword(e.target.value)}
                    />
                  </div>

                  <div className="text-center">
                    <label className="inline-flex items-center cursor-pointer mb-2">
                      Please, contact us if you have any problem with registration.
                    </label>
                    <div className="inline-flex items-center cursor-pointer mb-2 font-bold">
                      mblinktools@gmail.com
                    </div>
                  </div>
                  <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox text-gray-800 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                        checked={enableSubmit}
                        onChange={()=>{setEnableSubmit(!enableSubmit);}}
                      />
                      <span className="ml-2 text-sm font-semibold text-gray-700">
                        I agree with the{" "}
                        <a
                          href="#register"
                          className="text-blue-500"
                          onClick={(e) => {e.preventDefault(); showModal("Privacy Policy",<span>At MBLink, accessible from mblink.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by MBLink and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in MBLink. Mblink can delete or add new features, both on the website and in the app. This is at the sole discretion of Mblink. This policy is not applicable to any information collected offline or via channels other than this website. Users who use MBLink systems accept that they take all risks. It cannot be held responsible for errors that may occur by users using the MBLink system in any way. Reserves the right to update MBLink Systems.<br/><b>Consent:</b><br/>By using our website, you hereby consent to our Privacy Policy and agree to its terms. <br/><b>Purchase:</b><br/>Payments for credit purchases are made on Paypal. You accepts all payments made via Paypal in advance.<br/><b>Refund conditions:</b><br/> It is possible to refund only unused credits. Purchase and usage processes are followed from mblink. Our customers who have purchased a membership cannot make a refund after the first transaction/process after the start of the membership.<br/><b>Map Codes:</b><br/>When generating a map code, entering the VIN number incorrectly or selecting the wrong version is the responsibility of the user. The user is responsible for the codes generated and cannot be refunded in any way. Map codes are NOT included into Membership period.<br/><b>Confiscation:</b><br/> If we detect any cracking or hacking on our site or program, we may close your account indefinitely and without warning, and confiscate the credits it has received. These credits will not be refunded.<br/>If our users who have purchased a membership give their account to another user for shared usage, or if any abuse is detected, their membership will be terminated completely.</span>); }}
                        >
                          Privacy Policy
                        </a>
                      </span>
                    </label>
                  </div>
                  { showAlert ? showInfo() : null }

                  <div className="text-center mt-6">
                    <button
                      className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={(e) => registerUser(e)}
                    >
                      Create Account
                    </button>
                  </div> 
                  <div className="text-gray-500 text-center mb-1 font-bold">
                      <Link to="/auth/login" className="text-sm text-gray-500 font-bold">
                              Sign In MBLink
                          </Link>
                      </div>                   
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
